<template>
  <layout>
    <template v-slot:header>
      <global-navigation></global-navigation>
    </template>

    <main v-if="hasPage" class="Page">
      <paw v-if="isNotFound" />
      <section class="content">
        <h1>{{ page.title }}</h1>
        <rich-text 
          :class="{ 'not-found': isNotFound, 'default': true }" 
          :content="page.text"
        />
      </section>
    </main>

    <template v-slot:footer>
      <global-footer :border="hasBorder"></global-footer>
    </template>
  </layout>
</template>

<script>
import PageMixin from '@/mixins/PageMixin'
import RichText from '@/components/RichText'
import Paw from '@/components/Paw'

export default {
  name: 'Page',
  mixins: [ PageMixin ],
  components: { RichText, Paw },
  computed: {
    hasBorder () {
      return this.hasPage && (!!this.page.videofile || !!(this.page.featuredimage && this.page.featuredimage.large))
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 3.4rem;
  text-align: center;
  margin-bottom: 1em;
}

.not-found {
  text-align: center;
  font: var(--nord);
  text-transform: uppercase;
}

.content { padding: 4rem 25% 6rem 25%; }

@media (max-width: 1360px) {
  .content { padding: 4rem 20%; }
}

@media (max-width: 1000px) {
  .content { padding: 4rem 2rem }
}
</style>